<template>
    <div class="table-headers">
        <div
            class="table-header-cell record-id-header"
            :style="{
                width: getColumnWidth('record-id') + 'px',
                minWidth: getColumnWidth('record-id') + 'px',
            }"
        >
            <a-checkbox
                :checked="isAllSelected"
                @change="$emit('toggle-select-all', $event.target.checked)"
            ></a-checkbox>

            <!-- Table Actions Menu - Yetkili kullanıcılara göster -->
            <a-popover v-if="canShowPermissionSettings" trigger="click" placement="bottomLeft">
                <template slot="content">
                    <div class="action-list table-actions-menu">
                        <div class="action-item" @click="goToPermissionSettings">
                            <i class="material-icons">admin_panel_settings</i>
                            <span>Gizlilik Ayarları</span>
                        </div>
                    </div>
                </template>
                <i class="material-icons table-actions-icon" @click.stop>more_vert</i>
            </a-popover>

            <!-- Resize Handle for ID column -->
            <div class="resize-handle" @mousedown="startResize($event, 'record-id')" @click.stop></div>
        </div>
        <draggable :list="$_.cloneDeep(visibleFields)" @end="onDragEnd" class="drag-context-wrapper">
            <div
                v-for="field in visibleFields"
                :key="field._id"
                class="table-header-cell"
                :class="{ selected: selectedField === field, identifier: field.isIdentifierField }"
                :style="{
                    width: getColumnWidth(field._id) + 'px',
                    minWidth: getColumnWidth(field._id) + 'px',
                }"
                @click="selectField(field)"
            >
                <a-popover trigger="click" placement="bottomLeft">
                    <template slot="content">
                        <div class="action-list field-actions-menu">
                            <PermissionController :permissions="['table.update']">
                                <div class="action-item" @click="handleAction('editField', field)" v-if="!moduleMode">
                                    <i class="material-icons">edit</i>
                                    <span>{{ $t("tables.editField") }}</span>
                                </div>
                            </PermissionController>
                            <a-divider v-if="!moduleMode" />
                            <div class="action-group">
                                <div class="group-name">{{ $t("tables.sort") }}</div>
                                <div
                                    class="action-item"
                                    :class="{
                                        disabled:
                                            field.valueType === 'array' ||
                                            (isSortActive(field._id) && currentSort.direction === 'asc'),
                                    }"
                                    @click="
                                        field.valueType !== 'array' &&
                                            !(isSortActive(field._id) && currentSort.direction === 'asc') &&
                                            handleAction('sortAscending', field)
                                    "
                                >
                                    <i class="material-icons">arrow_upward</i>
                                    <span>Sırala A-Z</span>
                                </div>
                                <div
                                    class="action-item"
                                    :class="{
                                        disabled:
                                            field.valueType === 'array' ||
                                            (isSortActive(field._id) && currentSort.direction === 'desc'),
                                    }"
                                    @click="
                                        field.valueType !== 'array' &&
                                            !(isSortActive(field._id) && currentSort.direction === 'desc') &&
                                            handleAction('sortDescending', field)
                                    "
                                >
                                    <i class="material-icons">arrow_downward</i>
                                    <span>Sırala Z-A</span>
                                </div>
                                <div
                                    class="action-item"
                                    :class="{
                                        disabled: field.valueType === 'array' || !isSortActive(field._id),
                                    }"
                                    @click="
                                        field.valueType !== 'array' &&
                                            isSortActive(field._id) &&
                                            handleAction('clearSort', field)
                                    "
                                >
                                    <i class="material-icons">clear</i>
                                    <span>Sıralamayı Kaldır</span>
                                </div>
                                <PermissionController :permissions="['table.update']">
                                    <div
                                        class="action-item"
                                        @click="handleAction('makeIdentifier', field)"
                                        v-if="!field.isIdentifierField && isValidForIdentifier(field)"
                                    >
                                        <i class="material-icons">check_circle</i>
                                        <span>{{ $t("Mark as Identifier Field") }}</span>
                                    </div>
                                </PermissionController>
                                <PermissionController :permissions="['table.update']">
                                    <div
                                        class="action-item"
                                        @click="handleAction('runAI', field)"
                                        v-if="field.fieldType === 'ai'"
                                    >
                                        <i class="material-icons">auto_awesome</i>
                                        <span>{{ $t("Yapay Zekayı Çalıştır") }}</span>
                                    </div>
                                </PermissionController>
                            </div>
                            <a-divider />
                            <PermissionController :permissions="['table.update']" controller="every">
                                <div class="action-group" v-if="false">
                                    <div class="group-name">{{ $t("tables.createField") }}</div>
                                    <PermissionController :permissions="['table.update']">
                                        <div class="action-item" @click="handleAction('insertBefore', field)">
                                            <i class="material-icons">add</i>
                                            <span>{{ $t("tables.insertBefore") }}</span>
                                        </div>
                                    </PermissionController>
                                    <PermissionController :permissions="['table.update']">
                                        <div class="action-item" @click="handleAction('insertAfter', field)">
                                            <i class="material-icons">add</i>
                                            <span>{{ $t("tables.insertBefore") }}</span>
                                        </div>
                                    </PermissionController>
                                </div>
                                <a-divider v-if="false" />
                            </PermissionController>
                            <PermissionController
                                :permissions="['automation.get', 'automation.create']"
                                controller="every"
                            >
                                <div class="action-group">
                                    <div class="group-name">{{ $t("ticimax.automation") }}</div>
                                    <PermissionController :permissions="['automation.get']">
                                        <div
                                            class="action-item"
                                            @click="handleAction('gotoAutomation', field)"
                                            v-if="field.fieldType === 'automation-button'"
                                        >
                                            <component is="AutomationIcon" class="myIcon" />
                                            <span>{{ $t("tables.goToRelatedAuto") }}</span>
                                        </div>
                                    </PermissionController>
                                    <PermissionController :permissions="['automation.create']">
                                        <div class="action-item" @click="handleAction('createAutomation', field)">
                                            <i class="material-icons">settings_suggest</i>
                                            <span>{{ $t("ticimax.createAutomation") }}</span>
                                        </div>
                                    </PermissionController>
                                </div>
                                <a-divider />
                            </PermissionController>
                            <PermissionController :permissions="['table.update']" controller="every">
                                <div class="action-group">
                                    <div class="group-name">{{ $t("tables.permission") }}</div>
                                    <PermissionController :permissions="['table.update']">
                                        <div class="action-item" @click="handleAction('lockField', field)">
                                            <i class="material-icons">lock</i>
                                            <span>{{ $t("tables.lockField") }}</span>
                                        </div>
                                    </PermissionController>
                                    <PermissionController :permissions="['table.update']">
                                        <div class="action-item" @click="handleAction('hideField', field)">
                                            <i class="material-icons">visibility_off</i>
                                            <span>{{ $t("tables.hideField") }}</span>
                                        </div>
                                    </PermissionController>
                                </div>
                                <a-divider />
                            </PermissionController>
                            <PermissionController :permissions="['table.update']">
                                <div class="action-item" @click="handleAction('deleteField', field)" v-if="!moduleMode">
                                    <i class="material-icons">delete</i>
                                    <span>{{ $t("tables.deleteField") }}</span>
                                </div>
                            </PermissionController>
                        </div>
                    </template>
                    <div class="table-header-cell-content">
                        <FieldIcon :type="field.fieldType" class="mr-2" :default-icon="field.icon" />
                        <span class="field-name">{{ field.name }}</span>
                        <i
                            v-if="isSortActive(field._id)"
                            class="material-icons sort-icon table-icon-max-width"
                            :class="{ 'sort-active': isSortActive(field._id) }"
                        >
                            {{ currentSort.direction === "asc" ? "arrow_upward" : "arrow_downward" }}
                        </i>
                    </div>
                </a-popover>

                <!-- Resize Handle -->
                <div class="resize-handle" @mousedown="startResize($event, field._id)" @click.stop></div>
            </div>
        </draggable>
        <!-- "Add Field" hücresi ve popover -->
        <PermissionController :permissions="['table.update']">
            <div class="table-header-cell add-field-cell" v-if="!moduleMode">
                <a-popover
                    v-model="isAddFieldPopoverVisible"
                    trigger="click"
                    placement="bottomRight"
                    overlayClassName="zero-padding"
                >
                    <template slot="content">
                        <FieldSelector @field-selected="openFieldCreator" @close="addFieldPopoverVisible = false" />
                    </template>
                    <span>+ {{ $t("calendar.addField") }}</span>
                </a-popover>
            </div>
        </PermissionController>

        <!-- FieldCreator'ı Modal2 içinde göster -->
        <Modal2
            v-if="isFieldCreatorVisible"
            :title="fieldCreatorMode === 'create' ? $t('tables.createNewField') : 'Alanı Düzenle'"
            @cancel="closeFieldCreator"
            :showFooter="false"
            className="field-creator-modal keydown-prevent-modal"
            xlarge
        >
            <FieldCreator
                :defaultFieldType="selectedFieldType"
                :table-id="table._id"
                :mode="fieldCreatorMode"
                :field="selectedField"
                @field-created-success="onFieldCreated"
                @field-updated-success="onFieldUpdated"
                @cancel="closeFieldCreator"
            />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import FieldSelector from "./components/FieldSelector.vue";
import FieldCreator from "./components/FieldCreator.vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import { TABLE_API } from "../../../../api/table";
import draggable from "vuedraggable";
import log2 from "../../../../utils/log2";
import FieldIcon from "../FieldIcon.vue";
import { mapActions, mapState } from "vuex";
import { canEditTablePermissions } from "../../../../utils/TablePermissionUtils";

const log = log2("TableHeaders");
export default Vue.extend({
    name: "TableHeaders",
    components: {
        FieldSelector,
        FieldCreator,
        Modal2,
        draggable,
        FieldIcon,
    },
    props: {
        table: {
            type: Object,
            required: true,
        },
        isSelectionModeActive: Boolean,
        selectedRecords: Array,
        isAllSelected: Boolean,
        visibleFields: {
            type: Array,
            required: true,
        },
        moduleMode: {
            type: Boolean,
            default: false,
        },
        currentSort: {
            type: Object,
            default: () => ({}),
        },
        columnWidths: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isFieldCreatorVisible: false,
            isAddFieldPopoverVisible: false,
            selectedFieldType: null,
            selectedField: null,
            fieldCreatorMode: "create",
            resizing: {
                isResizing: false,
                fieldId: null,
                startX: 0,
                startWidth: 0,
            },
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
        }),
        isRootUser() {
            // AdminUser varsa veya root kullanıcı ise true
            return this.adminUser || (this.user && this.user.role && this.user.role.isRoot);
        },
        canShowPermissionSettings() {
            return canEditTablePermissions(this.table, this.user, this.adminUser);
        },
    },
    methods: {
        ...mapActions({
            syncTables: "table/syncTables",
        }),
        isIdentifierField(field) {
            return field.isIdentifierField;
        },
        isValidForIdentifier(field) {
            //valueType string, number
            // or fieldType contact ,  user , linked-record
            return (
                ["string", "number"].includes(field.valueType) ||
                ["contact", "user", "linked-record"].includes(field.fieldType)
            );
        },
        move(event) {
            log("move", event);
            return false;
        },
        openFieldCreator(fieldType) {
            this.isAddFieldPopoverVisible = false;
            this.$feature.beforeCreateTableField(() => {
                this.selectedFieldType = fieldType;
                this.isFieldCreatorVisible = true;
                this.fieldCreatorMode = "create";
                this.selectedField = null;
            }, this.table.totalFields);
        },
        closeFieldCreator() {
            // Modal'ı kapat ve seçili fieldType'ı sıfırla
            this.isFieldCreatorVisible = false;
            this.selectedFieldType = null;
            // Popover'ı kapat
            this.isAddFieldPopoverVisible = false;
        },
        onFieldCreated() {
            // Üst componente tabloyu yenilemesini bildir
            this.$emit("refresh-table");
            // Modal'ı kapat
            this.closeFieldCreator();
        },
        handleAction(action, field) {
            switch (action) {
                case "editField":
                    this.selectedField = field;
                    this.fieldCreatorMode = "update";
                    this.isFieldCreatorVisible = true;
                    break;
                case "sortAscending":
                    this.$emit("sort-changed", {
                        field: field._id,
                        direction: "asc",
                        valueName: `${field.name}Value`,
                    });
                    break;
                case "sortDescending":
                    this.$emit("sort-changed", {
                        field: field._id,
                        direction: "desc",
                        valueName: `${field.name}Value`,
                    });
                    break;
                case "clearSort":
                    this.$emit("sort-changed", {});
                    break;
                case "insertBefore":
                    // Insert before logic
                    break;
                case "insertAfter":
                    // Insert after logic
                    break;
                case "createAutomation":
                    // Create automation logic
                    break;
                case "lockField":
                    // Lock field logic
                    break;
                case "hideField":
                    this.$emit("hide-field", field._id);
                    break;
                case "deleteField":
                    this.confirmDeleteField(field);
                    break;
                case "gotoAutomation":
                    const automationId = field.options.button.automation;
                    this.$router.push(`/automations/${automationId}/design`);
                    break;
                case "makeIdentifier":
                    this.makeIdentifier(field);
                    break;
                case "runAI":
                    this.showAIModal(field);
                    break;
            }
        },
        selectField(field) {
            this.selectedField = field;
        },
        async confirmDeleteField(field) {
            try {
                const confirmed = await this.$confirm({
                    title: "Alanı Sil",
                    content: `"${field.name}" alanını silmek istediğinize emin misiniz?`,
                    okText: "Evet",
                    okType: "danger",
                    cancelText: "Hayır",
                    onOk: async () => {
                        await TABLE_API.deleteField(this.table._id, field._id);
                        this.$emit("refresh-table");
                        this.$message.success("Alan başarıyla silindi.");
                        this.syncTables();
                    },
                });
            } catch (error) {
                if (error.message !== "cancel") {
                    log.error("Alanı silerken hata oluştu:", error);
                    this.$message.error("Alanı silerken bir hata oluştu.");
                }
            }
        },
        onFieldUpdated(updatedField) {
            const index = this.visibleFields.findIndex((field) => field._id === updatedField._id);
            if (index !== -1) {
                this.$set(this.visibleFields, index, updatedField);
            }
            this.closeFieldCreator();
        },
        async onDragEnd(event) {
            log(`drag from ${event.oldIndex} to ${event.newIndex}`);
            const movingField = this.visibleFields[event.oldIndex];
            const toField = this.visibleFields[event.newIndex];

            const oldPositionFieldNames = this.table.fields.map((x) => `${x.name} (${x.position})`);
            let fields = this.table.fields.map((x) => ({ name: x.name, pos: x.position, _id: x._id }));
            fields = _.orderBy(fields, ["pos"], ["asc"]);
            fields = fields.map((x, i) => ({ ...x, pos: i }));
            const movedFieldIndex = fields.findIndex((x) => x._id === movingField._id);
            const toFieldIndex = fields.findIndex((x) => x._id === toField._id);
            log("movingField", movingField.name, " index: ", movedFieldIndex);
            log("toField", toField.name, " index: ", toFieldIndex);
            fields.splice(movedFieldIndex, 1);
            fields.splice(toFieldIndex, 0, { name: movingField.name, pos: toField.position, _id: movingField._id });
            fields = fields.map((x, i) => ({ ...x, pos: i + 1 }));
            fields = _.sortBy(fields, ["pos"]);
            const newPositionFieldNames = fields.map((x) => `${x.name} (${x.pos})`);

            log("oldPositionFieldNames", oldPositionFieldNames);
            log("newPositionFieldNames", newPositionFieldNames);
            log("fields", fields);
            try {
                const positions = fields.reduce((acc, cur) => {
                    acc[cur._id] = cur.pos;
                    return acc;
                }, {});
                await TABLE_API.updateTableFieldPositions(this.table._id, positions);
                console.log("Alan pozisyonları başarıyla güncellendi.");
                this.$emit("positions-changed", positions);
            } catch (error) {
                console.error("Alan pozisyonları güncellenirken bir hata oluştu:", error);
            }
        },
        async makeIdentifier(field) {
            try {
                // Önce mevcut identifier field'ı false yap
                const currentIdentifierField = this.visibleFields.find((f) => f.isIdentifierField);
                if (currentIdentifierField) {
                    await TABLE_API.updateField(this.table._id, currentIdentifierField._id, {
                        isIdentifierField: false,
                    });
                }

                // Seçilen field'ı identifier olarak işaretle
                await TABLE_API.updateField(this.table._id, field._id, {
                    isIdentifierField: true,
                });

                this.$message.success(`${field.name} başarıyla tanımlayıcı alan olarak ayarlandı.`);
                this.$emit("refresh-table");
                this.syncTables();
            } catch (error) {
                console.error("Tanımlayıcı alan güncellenirken hata oluştu:", error);
                this.$message.error("Tanımlayıcı alan güncellenirken bir hata oluştu.");
            }
        },
        showAIModal(field) {
            this.$confirm({
                title: "Yapay Zekayı Çalıştır",
                content:
                    "Yapay zekayı hangi kapsamda çalıştırmak istiyorsunuz? Mevcut filtrelerinize uyan kayıtlar üzerinde mi yoksa tüm kayıtlar üzerinde mi çalışsın?",
                okText: "Mevcut Filtreler",
                cancelText: "Tüm Kayıtlar",
                onOk: () => this.triggerAI(field, true),
                onCancel: () => this.triggerAI(field, false),
            });
        },
        async triggerAI(field, useFilters) {
            try {
                const filters = useFilters ? this.filters : undefined;
                const query = useFilters ? this.searchQuery : undefined;
                await TABLE_API.triggerAIField(this.table._id, field._id, filters, query);
                this.$message.success(
                    "İşlem başlatıldı. Kayıt sayınıza göre bu işlemin süresi değişkenlik gösterebilir."
                );
            } catch (error) {
                console.error("Yapay zeka çalıştırılırken hata oluştu:", error);
                this.$message.error("Yapay zeka çalıştırılırken bir hata oluştu.");
            }
        },
        isSortActive(fieldId) {
            return this.currentSort && this.currentSort.field === fieldId;
        },
        goToPermissionSettings() {
            this.$router.push(`/tables/t/${this.table._id}/permissions`);
        },
        getColumnWidth(fieldId) {
            // Record ID kolonu için daha küçük varsayılan genişlik
            if (fieldId === "record-id") {
                return this.columnWidths[fieldId] || 100;
            }
            return this.columnWidths[fieldId] || 245;
        },
        startResize(event, fieldId) {
            event.preventDefault();
            event.stopPropagation();

            this.resizing = {
                isResizing: true,
                fieldId: fieldId,
                startX: event.clientX,
                startWidth: this.getColumnWidth(fieldId),
            };

            document.addEventListener("mousemove", this.handleResize);
            document.addEventListener("mouseup", this.stopResize);
            document.body.style.cursor = "col-resize";
            document.body.style.userSelect = "none";
        },
        handleResize(event) {
            if (!this.resizing.isResizing) return;

            const deltaX = event.clientX - this.resizing.startX;
            const newWidth = Math.max(100, this.resizing.startWidth + deltaX);

            this.$emit("column-width-changed", this.resizing.fieldId, newWidth);
        },
        stopResize() {
            this.resizing.isResizing = false;
            document.removeEventListener("mousemove", this.handleResize);
            document.removeEventListener("mouseup", this.stopResize);
            document.body.style.cursor = "";
            document.body.style.userSelect = "";
        },
    },
    beforeDestroy() {
        // Cleanup resize event listeners
        document.removeEventListener("mousemove", this.handleResize);
        document.removeEventListener("mouseup", this.stopResize);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
    },
});
</script>

<style scoped lang="scss">
.table-headers {
    width: max-content;
    display: flex;
    border-top: 1px solid #ccc;
    background: #e0e2e9;
    position: sticky;
    top: 0px;
    z-index: 99;

    .drag-context-wrapper {
        display: flex;
        width: max-content;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;

        &::-webkit-scrollbar {
            display: none;
        }
    }
}

.table-header-cell {
    padding: 0 15px;
    height: 40px;
    display: flex;
    align-items: center;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    position: relative;

    &.identifier {
        background: #beffbd !important;
    }

    &.selected {
        border: 2px solid #1890ff;
    }

    &:last-child {
        border-right: none;
    }

    .table-header-cell-content {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        font-weight: 800;
        color: #262626;
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        .table-icon-max-width {
            max-width: 18px !important;
        }

        .field-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            flex: 1;
            min-width: 0;
        }

        .sort-icon {
            margin-left: 5px;
            font-size: 16px;
            opacity: 0.6;
            flex-shrink: 0;

            &.sort-active {
                opacity: 1;
                color: #1890ff;
            }
        }
    }

    .resize-handle {
        position: absolute;
        top: 0;
        right: 0;
        width: 8px;
        height: 100%;
        cursor: col-resize;
        background: transparent;
        z-index: 10;

        &:hover {
            background: rgba(24, 144, 255, 0.2);
            border-right: 2px solid #1890ff;
        }

        &:active {
            background: rgba(24, 144, 255, 0.3);
            border-right: 2px solid #1890ff;
        }
    }
}

.add-field-cell {
    color: #007bff;
    cursor: pointer;
}

.material-icons {
    font-size: 18px;
}

.record-id-header {
    justify-content: center;
    gap: 5px;

    .table-actions-icon {
        font-size: 18px;
        cursor: pointer;
        color: var(--color-icon-default);
        opacity: 0.7;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 1;
        }
    }
}

.action-list {
    min-width: 200px;

    .action-item {
        display: flex;
        align-items: center;
        padding: 8px;
        cursor: pointer;

        &:hover {
            background-color: #f0f0f0;
        }

        i {
            margin-right: 8px;
        }
    }

    .action-group {
        .group-name {
            font-weight: bold;
            margin-bottom: 4px;
        }
    }
}
</style>
<style lang="scss">
.field-actions-menu {
    .ant-divider-horizontal {
        margin: 5px 0;
    }
}

.action-item {
    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;

        &:hover {
            background-color: transparent;
        }
    }
}
</style>
